import React from 'react';
import PropTypes from 'prop-types';
import { RESET, SEARCH } from '../constants';
const MobileFormToolbar = ({
  formId,
  handleReset
}) => /*#__PURE__*/React.createElement("div", {
  className: "filter__refine filter__refine--mobile-open"
}, /*#__PURE__*/React.createElement("div", {
  className: "reset",
  "data-testid": "reset-button",
  role: "button",
  onClick: handleReset,
  "aria-label": "Reset search filters"
}, RESET), /*#__PURE__*/React.createElement("button", {
  className: "search",
  type: "submit",
  form: formId
}, SEARCH));
MobileFormToolbar.propTypes = {
  formId: PropTypes.string.isRequired,
  handleReset: PropTypes.func.isRequired
};
export default MobileFormToolbar;
//# sourceMappingURL=MobileFormToolbar.js.map